import { useApi } from './useApi';

export function useCustomerRank() {
  const { fetchData, postData, putData, data, error, loading } = useApi();

  const createCustomerRankApi = async (credentials) => {
    try {
      const result = await postData('/api/customer_ranks', credentials);
      return {
        success: true,
        data: result
      };
    } catch (err) {
      return {
        success: false,
        error: err.message
      };
    }
  };

  const updateCustomerRankApi = async (id, credentials) => {
    try {
      const result = await putData(`/api/customer_ranks/${id}`, credentials);

      return {
        success: true,
        data: result
      };
    } catch (err) {
      return {
        success: false,
        error: err.message || 'Lỗi kết nối'
      };
    }
  };

  const getCustomerRanksApi = async (params = {}) => {
    try {
      const result = await fetchData('/api/customer_ranks', { params });

      return {
        success: true,
        data: result
      };
    } catch (err) {
      return {
        success: false,
        error: err.message || 'Lỗi kết nối'
      };
    }
  };

  return { createCustomerRankApi, getCustomerRanksApi, loading, updateCustomerRankApi };
}
